import { jsx as _jsx } from "react/jsx-runtime";
var Gift = function Gift(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M49.182 56h-15V40.725h17.454v12.851c0 1.339-1.099 2.424-2.454 2.424Zm-36.817-2.425V40.727h17.453V56h-15c-1.355 0-2.453-1.088-2.453-2.426Zm41.234-34.666h-4.912a7.534 7.534 0 0 0 .768-3.275c0-4.208-3.427-7.635-7.637-7.635-5.016 0-8.056 3.52-9.819 6.851-1.763-3.33-4.8-6.85-9.816-6.85-4.21 0-7.64 3.426-7.64 7.634 0 1.179.293 2.28.77 3.275h-4.911c-1.326 0-2.403 1.563-2.403 3.493v10.47c0 1.927 1.077 3.493 2.403 3.493h19.416V18.909h4.365v17.456h19.416c1.325 0 2.4-1.566 2.4-3.494V22.402c0-1.93-1.075-3.493-2.4-3.493Zm-11.781 0h-6.883c1.03-2.71 3.147-6.544 6.883-6.544a3.276 3.276 0 0 1 3.274 3.27 3.279 3.279 0 0 1-3.274 3.274Zm-19.635 0a3.279 3.279 0 0 1-3.275-3.275c0-1.803 1.47-3.27 3.275-3.27 3.736 0 5.853 3.835 6.883 6.545h-6.883Z",
      fill: color
    })
  });
};
export default Gift;